import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from './QuestionContainer';

const Q8 = ({ history }) => {
  const { t } = useTranslation();
  const Q8Options = useMemo(
    () => [
      {
        id: 0,
        name: t('yes'),
        value: 'yes',
      },
      {
        id: 1,
        name: t('no'),
        value: 'no',
      },
      {
        id: 2,
        name: t('dont_remember'),
        value: 'dont_remember',
      },
    ],
    [t]
  );

  return (
    <QuestionContainer
      history={history}
      title={t('question8')}
      options={Q8Options}
      nextUrl="q9"
      screenName="q8"
    />
  );
};

export default Q8;
